export enum Headers {
  Fingerprint = 'X-Device-Fingerprint'
}

export enum HttpStatuses {
  success = 200
}

export enum ErrorCodes {
  USER_ALREADY_EXIST = 'USER_ALREADY_EXIST',
  UNAUTHORIZED_USER = 'UNAUTHORIZED_USER',
  UNAUTHORIZED_DEVICE = 'UNAUTHORIZED_DEVICE',
  NEW_DEVICE = 'NEW_DEVICE',
  UNCONFIRMED_EMAIL = 'UNCONFIRMED_EMAIL',
  BLOCKED_USER = 'BLOCKED_USER',
  NOT_SIGNED_AGREEMENT = 'NOT_SIGNED_AGREEMENT',
  OLD_USER = 'OLD_USER',
  LOGIN_ACCESS = 'LOGIN_ACCESS',
  NEW_LOCATION = 'NEW_LOCATION',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
  BAD_REQUEST = 'BAD_REQUEST',
  SERVER_ERROR = 'SERVER_ERROR',
  USER_BLOCKED = 'USER_BLOCKED',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  THREAT_IP = 'THREAT_IP',
  NOT_FOUND = 'NOT_FOUND',
  IP_ALREADY_IN_WHITELIST = 'IP_ALREADY_IN_WHITELIST'
}

export type RequestMethod = 'GET' | 'POST' | 'DELETE';
export interface RequestHeader {
  name: string;
  value: string;
}

export interface ServiceResponse<TSuccess, TError> {
  error: TError | null;
  body: TSuccess | null;
  status?: number;
}
export interface ResponseErrorBody {
  code: ErrorCodes;
  error: string;
  data?: any;
}
export interface ResponseErrorBodyDataUnconfirmedEmail {
  uid: string;
}
export interface ResponseErrorBodyDataNewLocation {
  city: string;
  region: string;
  countryName: string;
  continentName: string;
  latitude: number;
  longitude: number;
}
export interface ResponseErrorBodyDataValidationError {
  errors: ValidationError[];
}
export interface ValidationError {
  code: ValidateErrorCodes;
  field: string;
}
export interface ResponseErrorBodyDataNotSignedAgreement {
  agreements: Agreement[];
}

export interface ResponseErrorBodyOldUser extends ResponseErrorBody {
  data: ResponseErrorOldUser;
}
export interface ResponseErrorOldUser {
  userId: string;
  email: string;
}

export interface RequestParamsUsers {
  email: string;
  password: string;
  firstName: string;
  secondName: string | null;
  lastName: string;
  company: string | null;
  phone: string | null;
  birthDay: string | null;
  position: string | null;
  profession: string | null;
  sex: Sex;
  agreements: Agreement[];
}
export enum Sex {
  male = 'male',
  female = 'female'
}
export enum ValidateErrorCodes {
  REQUIRED_FIELD = 'REQUIRED_FIELD',
  MAX_LENGHT = 'MAX_LENGHT',
  EMAIL_IN_USE = 'EMAIL_IN_USE',
  INVALID_PHONE = 'INVALID_PHONE',
  INVALID_DATE = 'INVALID_DATE',
  INVALID_VALUE = 'INVALID_VALUE'
}

export interface RequestParamsLogin {
  email: string;
  password: string;
}
export interface ResponseSuccessBodyLogin {
  success: boolean;
  url: string;
}

export interface ResponseSuccessGetPasswordSet {
  set: boolean;
}

export interface flagUser {
  datetime: string;
  id: string;
}

export interface ResponseSuccessBodyUserInfo {
  uid: string;
  email: string;
  roles: string[];
  firstName: string;
  lastName: string;
  birthday: string;
  phone: string;
  telegram: string;
  position: string;
  photo: string;
  flags: {
    agreements: flagUser[];
  };
}

export interface RequestParamsChangepassword {
  password: string;
  agreements: Agreement[];
}

export interface RequestParamsSetupPassword {
  password: string;
}

export interface RequestParamsPasswordRecovery {
  email: string;
}

export type Agreement = 'privacy_policy_v1' | 'terms_of_use_v1';

export interface RequestParamsLoginWithInternalUrl {
  agreements: AgreementDomRF[];
}

export type AgreementDomRF =
  | 'privacy_policy_v1'
  | 'terms_of_use_v1'
  | 'privacy_policy_domrf';

export interface RequestParamsAgreements {
  agreements: Agreement[];
}

export interface RequestParamsMonolith {
  email: string;
  password: string;
  userId: string;
  agreements: Agreement[];
}

export type ResponseSuccessBodyDevices = Device[];
export interface Device {
  deviceId: string;
  userAgent: string;
  ip: string;
  lastActiveAt: string;
  createdAt: string;
}

// ------------------------------------------------------------

export interface RegistrationForm {
  email?: string;
  password?: string;
  firstName?: string;
  secondName?: string;
  lastName?: string;
  company?: string;
  phone?: string;
  birthDay?: Date;
  position?: string;
  profession?: string;
  sex?: Sex;
  agreements: boolean;
}

export interface LoginForm {
  email: string;
  password: string;
}

export interface CreateUserForm {
  email: string;
  firstName?: string;
  secondName?: string;
  password: string;
  confirmedPassword: string;
  agreements: boolean;
  promotional: boolean;
}

export interface CreateUserRequest {
  email: string;
  firstName?: string;
  secondName?: string;
  password: string;
}

export interface ChangePasswordForm {
  password: string;
  confirmedPassword: string;
}

export interface ValidatePassword {
  password: string;
}

export interface ValidateEmail {
  email: string;
}

export interface EditPassword {
  oldPassword: string;
  password: string;
  confirmedPassword: string;
}

export interface EditPasswordForm {
  oldPassword: string;
  password: string;
}

export interface OldUserForm {
  password: string;
  confirmedPassword: string;
  email: string;
}

export interface DeviceListItem {
  device: Device;
  disabled: boolean;
}

export interface WizardForApproveStep {
  isNextDisabled: () => boolean;
  content: React.ReactNode;
}

// ------------------------------------------------------------

type RequestIdleCallbackHandle = any;
type RequestIdleCallbackOptions = {
  timeout: number;
};
type RequestIdleCallbackDeadline = {
  readonly didTimeout: boolean;
  timeRemaining: () => number;
};

declare global {
  interface Window {
    requestIdleCallback: (
      callback: (deadline: RequestIdleCallbackDeadline) => void,
      opts?: RequestIdleCallbackOptions
    ) => RequestIdleCallbackHandle;
    cancelIdleCallback: (handle: RequestIdleCallbackHandle) => void;
  }
}

// ------------------------------------------------------------

export interface Settings {
  language?: string;
  layoutWidth: Width;
}

export type Width = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;

export type SettingsContextType = Settings & {
  setLanguage(language: string): void;
  setLayoutWidth(width: Width): void;
};

export interface GlobalErrorContextType {
  globalError?: ResponseErrorBody | string;
  setGlobalError: (error: ResponseErrorBody | string) => void;
}

export enum ConfirmIpCodes {
  NOT_FOUND = 'NOT_FOUND',
  IP_ALREADY_IN_WHITELIST = 'IP_ALREADY_IN_WHITELIST',
  SERVER_ERROR = 'SERVER_ERROR'
}
